<template>
  <div>
    <fccTable
      striped
      hover
      responsive
      search
      pagination
      :fields="fields"
      :items="listaOpcoes"
      :porPage="itemsPorPage"
      @row-selected="selecionaLinha"
    />

    <div class="text-right mb-3">
      <fcc-button @click="importar" :disabled="dadosSelecionados.length === 0">Importar</fcc-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['listaOpcoes'],
  data() {
    return {
      fields: [
        {
          type: 'rowSelect',
          key: 'rowSelect',
          active: false
        },
        { key: 'tpapresentacao', label: 'Tipo Apresentação', sortable: true },
        { key: 'codigo', label: 'Código', sortable: true },
        { key: 'opcao', label: 'Opção', sortable: true },
        { key: 'rotulo', label: 'Rótulo', sortable: true }
      ],
      itemsPorPage: '10',
      dadosSelecionados: []
    }
  },
  methods: {
    selecionaLinha(value) {
      this.dadosSelecionados = value
    },
    importar() {
      this.$emit('importar', this.dadosSelecionados)
    }
  }
}
</script>